import { useJoyride } from 'react-joyride';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const joyride_steps = [
    {
        target: 'body',
        content: 'Welcome! In FastMap Workspace, you have access to a variety of spatial datasets. This short tour will introduce you to the main features and show you how to navigate the Workspace effectively.',
        title: 'Welcome',
        placement: 'center',
        disableBeacon: true,
        spotlightClicks: false,
        spotlightPadding: 0,
    },
    {
        target: '[data-tour="step-1"]',
        content: (
            <>
                The search button lets you search for your desired location.<br />
                <b>Please click this button.</b>
            </>
        ),
        title: 'Search',
        beaconTopPosition: '-0.6rem',
    },
    {
        target: '[data-tour="step-2"]',
        content: (
            <>
                You can search for your desired location here just by typing the name and see matching suggestions. <br />
                For the sake of this tour, please search for <b>"Winnipeg, Manitoba"</b> and select it from the list.
            </>
        ),
        title: 'Search',
        placement: 'right',
    },
    {
        target: '[data-tour="step-3"]',
        content: 'After a dataset is loaded, these controllers appear in the footer of the map and let you select the data you desire to view on the map.',
        title: 'Dataset Controllers',
        beaconTopPosition: '-5rem',
    },
    {
        target: '[data-tour="step-4"]',
        content: (
            <>
                The collection menu gives you access to all the data collections available at the current map centre. You can select among orthophoto <b>Imageries</b>, digital elevation/surface models (<b>DEM</b>/<b>DSM</b>),
                <b> oblique</b> aerial imageries, street-level <b>panorama</b> images, and <b>Web-services</b>.
            </>
        ),
        title: 'Collections',
        beaconTopPosition: '-5rem',
    },
    {
        target: '[data-tour="step-5"]',
        content: 'The mission menu gives you access to all the misssions available in the selected data collection. Missions are defined using the date they were captured.',
        title: 'Missions',
        beaconTopPosition: '-5rem',
    },
    {
        target: '[data-tour="step-6"]',
        content: 'Using this button, you can view the metadata of the selected dataset. You have to be a paid plan member to access missions metadata.',
        title: 'Metadata',
        beaconTopPosition: '-5rem',
    },
    {
        target: '[data-tour="step-7"]',
        content: 'Using these tools, you can zoom in/out or switch to 3D view to better view 3D datasets.',
        title: 'Navigations',
        placement: 'left',
    },
    {
        target: '[data-tour="step-8"]',
        content: 'This toolbox lets you export a specific area from a dataset, either in a spatial format for mapping software or without spatial attributes for reports.',
        title: 'Export Tools',
        placement: 'right',
    },
];

function CustomBeacon({ step }) {
    return (
        <span className="inline-flex" style={{ position: "relative", width: '3rem', height: '3rem', top: step.beaconTopPosition || '0px' }}>
            <span style={{ position: 'absolute', inset: '0rem', borderRadius: '50%', backgroundColor: 'rgba(72, 122, 242, 0.6)' }} />
            <span style={{ position: 'absolute', inset: '0rem', borderRadius: '50%', backgroundColor: 'rgba(72, 122, 242, 0.6)', animation: 'customSimplePulse 1s infinite cubic-bezier(0,0,0.2,1)' }} />
        </span>
    );
}

const GuidedTour = () => {
    const dispatch = useDispatch();
    const [run, setRun] = useState(false);
    const showGuidedTour = useSelector(state => state.settings.showGuidedTour);

    const { controls, on, state, Tour } = useJoyride({
        continuous: true,
        debug: false,
        onEvent: (data) => {
            if (data.type === 'tour:end' || data.type === 'tour:status') {
                if (data.status === 'finished' || data.status === 'skipped') {
                    dispatch({ type: 'TOGGLE_GUIDED_TOUR', show: false });
                }
            }
            if (data.type === 'beacon' && data.status === 'running') {
                controls.reset();
                dispatch({ type: 'TOGGLE_GUIDED_TOUR', show: false });
            }
        },
        steps: joyride_steps,
        run,
        options: {
            buttons: ['back', 'primary', 'skip'],
            scrollOffset: 64,
            showProgress: true,
            skipScroll: true,
            spotlightPadding: 16,
            spotlightRadius: 16,
            beaconComponent: CustomBeacon,
        },
        styles: {
            options: {
                zIndex: 100000,
            },
        }
    });

    useEffect(() => {
        if (showGuidedTour === undefined) return;

        setRun(showGuidedTour);
    }, [showGuidedTour]);

    useEffect(() => {
        on('tour:end', () => {
            controls.reset();
            dispatch({ type: 'TOGGLE_GUIDED_TOUR', show: false });
        });
    }, [controls, on]);

    return (<div>{Tour}</div>);
}

export default GuidedTour;